module.exports = __webpack_public_path__ + "img/corner_logo.d22f3ccc.svg";